/**
 * License Renewal.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_RENEWAL = 'license-renewal';
//# sourceMappingURL=LICENSE_RENEWAL.js.map